import { motion } from "framer-motion";
import { Box, Typography } from "@mui/material";
import { tokens } from "../theme";

const StartCard = ({ name, icon: Icon, value, background, color }) => {
  return (
    <motion.div
      style={{
        border: "1.5px solid #e5e7eb",
        background: "#fff ",
        borderRadius: "10px",
        padding: "16px 18px",
        width: "230px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {/* Left Side: Title + Value */}
      <Box display="flex" flexDirection="column" justifyContent="space-between" width="70%">
        <Typography variant="body2" sx={{ fontSize: "14px", fontWeight:400, color: "#535353" }}>
          {name}
        </Typography>
        <Box display="flex" mt={1}>
          <Typography variant="h3" fontWeight="bold" sx={{ color: color, fontSize: "22px" }}>
            {value}
          </Typography>
        </Box>
      </Box>

      {/* Right Side: Icon */}
      <Box
        sx={{
          width: "30px",
          height: "30px",
          background: tokens.redAccent[100],
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon style={{ fontSize: 18, 
                       color: tokens.redAccent[400], 

        }} />
      </Box>
    </motion.div>
  );
};

export default StartCard;

